<template>
  <div id="salesmanList" v-loading="exportLoading">
    <el-card>
      <!-- 查询选项 -->
      <Form class="salesmanForm" :label-width="160">
        <FormItem class="form_item" :label="$t('employeeName1')">
          <Input clearable v-model="employeeName" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('country1')">
          <el-select  v-model="country" clearable :placeholder="$t('select')">
            <el-option v-for="item in CountryList" :key="item.value" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('labourRateType1')">
          <el-select  v-model="labourRateType" clearable :placeholder="$t('select')">
            <el-option v-for="item in LabourRateTypeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <div class="buttonDiv">
          <el-button type="primary" size="mini" @click="searchProjectByPage">{{$t('search')}}</el-button>
          <el-button  type="primary" size="mini" @click="exportExcel">{{$t('export')}}</el-button>
          <el-button  type="primary" size="mini" @click="importExcel">{{$t('import')}}</el-button>
        </div>
      </Form>
      
      <div class="contentTableDiv">
        <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="id" v-if="false"></el-table-column> 
           <el-table-column prop="userId" :label="$t('userId')"  align="left" :show-overflow-tooltip="true"></el-table-column> 
          <el-table-column prop="employeeId" :label="$t('employeeId')"  align="left" :show-overflow-tooltip="true"></el-table-column> 
          <el-table-column prop="employeeName" :label="$t('employeeName')" align="left" :show-overflow-tooltip="true">
            <!-- <template slot-scope="scope">
              <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.employeeName}}</a>
            </template> -->
          </el-table-column>
          <el-table-column prop="laborRate" :label="$t('laborRate')" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="country" :label="$t('country')" align="center" :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column prop="labourRateType" :label="$t('labourRateType')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
          <el-table-column prop="currency" :label="$t('currency2')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
          <!-- <el-table-column prop="createBy" :label="$t('createBy')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
          <el-table-column prop="updateBy" :label="$t('updateBy')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
          <el-table-column prop="createDt" :label="$t('createDt')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
          <el-table-column prop="updateDt" :label="$t('updateDt')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
          <el-table-column prop="dataStatus" :label="$t('dataStatus')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
          <el-table-column prop="remark" :label="$t('remark')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
          <el-table-column prop="islhToken" :label="$t('islhToken')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column> -->
        </el-table> 
      </div>
      <div class="pageDiv">
        <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10, 20,50,100]"
          :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>
    <Modal v-model="modelImport" :closable='true' :mask-closable='true' width="60%" title="Personnel">
      <div slot="footer"></div>
      <el-table :data="gridData" border style="width: 100%;" >
        <el-table-column label="Template Download" align="center">
          <template><el-button size="mini" type="primary" @click="downloadTemplate">{{'PersonnelTemplate'}}</el-button></template>
        </el-table-column>
        <el-table-column label="File Location" align="center">
          <el-upload ref="uploadFile" action="" :accept="acceptFileType" :limit="1" :on-exceed="handleExceed" :before-upload="beforeUpload" 
            :file-list="fileList" :auto-upload="false">   
            <el-button size="mini" type="primary">{{'Select File'}}</el-button>              
          </el-upload>
        </el-table-column>
        <el-table-column align="center">
          <el-button type="primary" size="mini" @click="submitUpload">{{'Confirm Import'}}</el-button>
        </el-table-column>
      </el-table>
    </Modal>
  </div>
</template>
<style scoped>

#salesmanList .salesmanForm .buttonDiv{
  margin-top:50px;
  margin-bottom: 10px;
}
.contentTableDiv{
  border:none !important;
}
</style>
<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'

    export default {
        name: 'personnel',
        created () {
          this.getParams();
          this.getPersonnelByPage();
          this.getDataList('Country');
          this.getDataList('LabourRateType');
        },
        data () {
          return {
            exportLoading:false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            multipleSelection: [],
            tableData: [],
            CountryList: [],
            LabourRateTypeList:[],
            modelImport:false,
            gridData:[{}],
            fileList:[],
            acceptFileType:'.xls,.xlsx',
            employeeName:null,
            country:null,
            labourRateType:null,
            islhToken:null,
          }
        },
        methods: {
           getParams(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
             let params = this.$route.params;
             this.currentPage = params.currentPage;
             this.pageSize = params.pageSize;
             this.employeeName = params.projectName;
             this.country = params.country;
             this.labourRateType = params.labourRateType;
            }
          },
          getDataList(type){
            let url =`${this.$store.state.islhurl}islhlaborrateinfo/getSelectData`;
            let pm = {
              selectType: type,
            }
            this._post(url,pm).then(
              res => {   
                if(type=='Country'){
                  this.CountryList = res.data;
                }else if(type='LabourRateType'){
                  this.LabourRateTypeList = res.data;
                }else{}
              }
            )
          },
          getPersonnelByPage(){
            let url = `${this.$store.state.islhurl}islhlaborrateinfo/getListPage/${this.pageSize}/${this.currentPage}`
            let pm = {
              employeeName: this.employeeName==''?null:this.employeeName,
              country: this.country==''?null:this.country,
              labourRateType: this.labourRateType==''?null:this.labourRateType,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.tableData =res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          searchProjectByPage(){
            this.pageSize = 10;
            this.currentPage = 1;
            let url = `${this.$store.state.islhurl}islhlaborrateinfo/getListPage/${this.pageSize}/${this.currentPage}`
            let pm = {
              employeeName: this.employeeName==''?null:this.employeeName,
              country: this.country==''?null:this.country,
              labourRateType: this.labourRateType==''?null:this.labourRateType,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.tableData =res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          importExcel(){
            this.fileList = [];
            this.modelImport = true;
          },
          handleExceed(files,fileList){
            this.$message.warning('Please delete the uploaded file first!');
          },
          downloadTemplate(){
            window.location.href = `${this.$store.state.islhurl}`+"islhlaborrateinfo/downChipTemplate?fileName=Labor_Rate_Template.xlsx";
          },
          submitUpload(){
            if(this.$refs.uploadFile.$children[0].fileList.length == 1){
                this.$refs.uploadFile.submit();
            }else{
              this.$message({
                type:'error',
                showClose:true,
                duration:5000,
                message:'Please select file first!'
              });
            };
          },
          beforeUpload(file){
            var fileName = file.name.substring(file.name.lastIndexOf('.')+1);
            if(fileName != 'xls' && fileName != 'xlsx'){
              this.$message({
                type:'error',
                showClose:true,
                duration:5000,
                message:'Please select .xls or .xlsx file!'
              });
              return false;
            }
            this.downloadLoading = this.$loading({
              lock:true,
              text:'Data is importing...',
              spinner:'el-icon-loading',
              background:'rgba(0,0,0,0.7)'
            });
            this.modelImport = false;
            let fd = new FormData();
            fd.append('file',file);
            fd.append('islhToken',sessionStorage.getItem("islhtoken"));
            let url = `${this.$store.state.islhurl}islhlaborrateinfo/importData`
            this._post(url,fd).then(
              res =>{
                this.downloadLoading.close();
                if(res=="200"){
                  this.$message.success('Operation Complete！');
                  this.getPersonnelByPage();
                }else{
                  this.$message({
                    type:'error',
                    showClose:true,
                    duration:10000,
                    dangerouslyUseHTMLString: true,
                    message:res
                  });
                }
              }
            )
          },
          handleSelectionChange(val) {
            this.multipleSelection = val;
          },
          exportExcel(){
            this.exportLoading = true;
            let execlName = 'Personnel Labor Rate.xlsx';
            const length = this.multipleSelection.length;
            let ids = [];
            for (let i = 0; i < length; i++) {
              ids.push(this.multipleSelection[i].id)
            }
            this.$axios({
              url: `${this.$store.state.islhurl}islhlaborrateinfo/exportData`,
              method: 'post',
              data: {
                ids: ids,
                employeeName: this.employeeName==''?null:this.employeeName,
                country: this.country==''?null:this.country,
                labourRateType: this.labourRateType==''?null:this.labourRateType,
                islhToken : sessionStorage.getItem('islhtoken'),
              },
              responseType:"blob"
            }).then(response=>{
              this.exportLoading = false;
              const blob = new Blob([response.data])
              const aEle = document.createElement('a');     // 创建a标签
              const href = window.URL.createObjectURL(blob);       // 创建下载的链接
              aEle.href = href;
              aEle.download = execlName;  // 下载后文件名
              document.body.appendChild(aEle);
              aEle.click();     // 点击下载 
              document.body.removeChild(aEle); // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            })
          },
        
          changePage (val) {
            this.currentPage = val;
            this.getPersonnelByPage();
          },
          // 改变当前页显示条数
          changePageSize (val) {
            this.pageSize = val;
            this.getPersonnelByPage();
          },
          
          loadMore(n) {
            // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
            // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
            return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数,可自定义
          },
        },
        directives:{
          'el-select-loadmore':(el, binding) => {
            // 获取element-ui定义好的scroll盒子
            const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
            if(SELECTWRAP_DOM){
              //解除绑定事件
              el.unbindEventListener = () => {
                SELECTWRAP_DOM.removeEventListener("scroll", function () {
                  const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                  if (condition) binding.value();
                });
              }
              //绑定事件
              SELECTWRAP_DOM.addEventListener("scroll", function () {
                /**
                 * scrollHeight 获取元素内容高度(只读)
                 * scrollTop 获取或者设置元素的偏移值,
                 *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                 * clientHeight 读取元素的可见高度(只读)
                 * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                 * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                 */
                const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (condition) binding.value();
              });
            }
          },
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/personnel/personnelList.vue